import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SettingService } from './setting.service';
import { Observable } from 'rxjs';

@Injectable()
export class ScoringService {
  constructor(private settings: SettingService,
              private http: HttpClient) {
  }
  api = 'school-program-http/api/v1';
  
  getScoreDetail(school_program_activity_id: any, params: any): Observable<any> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/scoring-detail/' + school_program_activity_id;
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/scoring-detail/' + school_program_activity_id;

    return this.http.get<any>(requestUrl, {
      ...this.settings.httpOptionWithSession(),
      params: new HttpParams({ fromObject: params }),
    });
  }

  getStudentScore(school_program_activity_id: any, period_id: any): Observable<any> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/score-student/' + school_program_activity_id + '/' + period_id;
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/score-student/' + school_program_activity_id + '/' + period_id;

    return this.http.get<any>(requestUrl, this.settings.httpOptionWithSession());
  }

  saveStudentsScore(school_program_activity_id: number, param: any): Observable<any> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/score-save/' + school_program_activity_id;
    // const requestUrl = 'http://localhost:3073/school-program-http/api/v1/score-save/' + school_program_activity_id;

    return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(param)), this.settings.httpOptionWithSession());
  }

  scoringTemplate(school_program_activity_id: number, params: any): Observable<Blob> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/generate-scoring-template/' + school_program_activity_id;
    // const requestUrl = 'http://localhost:3073/school-program-http/api/v1/generate-scoring-template/' + school_program_activity_id;

    // return this.http.get<Blob>(requestUrl, {headers: this.settings.httpOptionWithToken().headers.set(
    //   'Accept',
    //   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    // ), responseType: 'blob' as 'json'});
    return this.http.get<any>(requestUrl, {
      ...this.settings.httpOptionWithSession(),
      params: new HttpParams({ fromObject: params }),
      responseType: 'blob' as 'json',
    }); 
  }

  uploadScore(params: any) {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/upload-score';
    // const requestUrl = 'http://localhost:3073/school-program-http/api/v1/upload-score';

    return this.http.post<any>(requestUrl, params, this.settings.httpOptionWithSession());
  }

}
